<div *ngIf="showShoppingCar" class="shopping-car">
  <div (click)="openShoppingCar()" class="background"></div>

  <!-- LOADER -->
  <div *ngIf="statusCard == 1" class="card center">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>

  <!-- LISTADO -->
  <div *ngIf="statusCard == 2" class="card">
    <div class="header-card">
      <span class="title_">Resumen de tu orden</span>
      <span class="number-items">{{ listProductShoppingCar.length }} Items</span>
    </div>
    <div class="body-card">
      <div *ngFor="let product of listProductShoppingCar" class="container-item"
        [ngClass]="{'delete': product.selected}">
        <div class="container-info-product">
          <div class="container-img-info">
            <div class="container-img">
              <img [src]="product.image" alt="" class="img-product">
              <span class="volume-product"> {{ product.quantity }} </span>
            </div>
            <div class="container-info">
              <span class="name-product truncate"> {{ product.name }} </span>
              <span class="description-product truncate"> {{ product.description }} </span>
            </div>
          </div>
          <div class="container-btns">
            <div (click)="tryDeleteProduct(product)" class="container-icon">
              <img src="/assets/icons/delete.svg" alt="" class="icon">
            </div>
            <!-- <div (click)="editProduct(product.id)" class="container-icon">
              <img src="/assets/icons/edit.svg" alt="" class="icon">
            </div> -->
          </div>
          <span class="amount-product">{{ product.total | currency:'USD':symbol:'1.0-0' }} </span>
        </div>
        <div class="container-delete-product">
          <div class="container-info-delete">
            <span class="text-confirm">¿Seguro que deseas eliminarlo?</span>
            <span class="name-product margin-top-03"> {{ product.name }} </span>
          </div>
          <div class="container-btns-delete">
            <span (click)="cancelTryDeleteProduct()" class="btn-delete no-fill">No</span>
            <span (click)="deleteproduct(product)" class="btn-delete fill">Si</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="deletingOrder" class="footer-card center">
      <a class="delete-order">Eliminando...</a>
    </div>
    <div *ngIf="!deletingOrder" class="footer-card">
      <a *ngIf="!tryDeleteOrder" (click)="tryDeleteOrderF(true)" class="delete-order">Eliminar orden</a>
      <div *ngIf="tryDeleteOrder" class="container-btns-delete">
        <span (click)="tryDeleteOrderF(false)" class="btn-delete no-fill">No</span>
        <span (click)="deleteOrder()" class="btn-delete fill">Si</span>
      </div>
      <a (click)="goCheckout()" class="container-pay-order">
        <span class="name-btn">Realizar orden</span>
        <span class="amount"> {{ total | currency:'USD':symbol:'1.0-0' }} </span>
      </a>
    </div>
  </div>

  <!-- LISTADO -->
  <div *ngIf="statusCard == 3" class="card center">
    <span class="text-center">No tiene productos <br> agregados</span>
  </div>

</div>